import createVueComponent from '../createVueComponent';
var Percent = createVueComponent('PercentIcon', [['line', {
  x1: '19',
  y1: '5',
  x2: '5',
  y2: '19',
  key: 't1677v'
}], ['circle', {
  cx: '6.5',
  cy: '6.5',
  r: '2.5',
  key: '4mh3h7'
}], ['circle', {
  cx: '17.5',
  cy: '17.5',
  r: '2.5',
  key: '1mdrzq'
}]]);
export default Percent;